import useApi from "../../api/useApi";

const useMessengerService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, latestMessageId) => {

    return api(
      'get',
      'user/messages/'+latestMessageId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useMessengerService::api: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userSend = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'user/messages/send',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useMessengerService::userSend: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userRead = (callbackSuccess, callbackValidationErrors, conversationId) => {
    return api(
      'post',
      'user/messages/read',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useMessengerService::userRead: ${error?.message || JSON.stringify(error)}`)},
      conversationId,
    )
  }

  const countNotifications = (callbackSuccess, callbackValidationErrors, companyId) => {
    return api(
      'get',
      'user/notifications/'+companyId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useMessengerService::countNotifications: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    userSend,
    userShow,
    userRead,
    countNotifications,
  }
}

export default useMessengerService
